"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKeyset = createKeyset;
const langs_1 = require("../langs");
function isNotEmpty(value) {
    return typeof value === 'object' ? Boolean(value.one) : Boolean(value);
}
function getTranslate(keysetEntry, lang) {
    if (isNotEmpty(keysetEntry[lang])) {
        return keysetEntry[lang];
    }
    return undefined;
}
function createKeyset(fileKeyset, lang) {
    return Object.keys(fileKeyset).reduce((i18nKeyset, key) => {
        const translates = fileKeyset[key];
        if (!translates) {
            return i18nKeyset;
        }
        const processedLangs = lang ? [lang] : langs_1.AVAILABLE_LANGS;
        processedLangs.forEach(l => {
            const value = getTranslate(translates, l);
            if (!value) {
                return;
            }
            if (!i18nKeyset[l]) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
                i18nKeyset[l] = {};
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- DIRECT-239681
            // @ts-ignore Проверил на предыдущем шаге, что i18nKeyset[l] не undefined.
            i18nKeyset[l][key] = value;
        });
        return i18nKeyset;
    }, {});
}
